import {Get, Delete} from "../index";

let objectsController;

const GetObjects = (lat, lng, search) => {
    if (objectsController) {
        objectsController.abort("deduplication")
    }

    objectsController = new AbortController();
    return Get("objects", {
        ...lat ? {lat} : {},
        ...lng ? {lng} : {},
        ...search ? {search} : {},
    }, objectsController.signal)
}

let objectController;

const GetObject = (id) => {
    if (objectController) {
        objectController.abort("deduplication")
    }
    objectController = new AbortController();
    return Get("objects/" + id, {}, objectController.signal)
}

let cardsController;

const GetObjectCards = (objectId) => {
    if (cardsController) {
        cardsController.abort("deduplication")
    }
    cardsController = new AbortController()
    return Get("payments/v2/cards", {object_id: objectId }, cardsController.signal)
}


const GetCards = () => {
    if (cardsController) {
        cardsController.abort("deduplication")
    }
    cardsController = new AbortController()
    return Get("payments/v2/cards", null, cardsController.signal)
}


const RemoveCard = (aid, id) => {
    return Delete("payments/v2/cards/" + aid + "/" + id)
}

export {GetObjects, GetObject, GetCards, RemoveCard, GetObjectCards}